import React, { FunctionComponent } from 'react';

import { $ActionRow, $NakedActionRow } from './ActionRow.styles';

interface ActionRowProps {
  withoutMarginBottom?: boolean;
  withoutPadding?: boolean;
  isNaked?: boolean;
}

const ActionRow: FunctionComponent<React.PropsWithChildren<ActionRowProps>> = ({
  children,
  withoutMarginBottom = false,
  withoutPadding = false,
  isNaked = false,
}) => {
  if (isNaked) {
    return <$NakedActionRow>{children}</$NakedActionRow>;
  }

  return (
    <$ActionRow
      $withoutMarginBottom={withoutMarginBottom}
      $withoutPadding={withoutPadding}
    >
      {children}
    </$ActionRow>
  );
};

export default ActionRow;
